/** @format */

import { Row, Col, DatePickerProps, Radio, RadioChangeEvent, message, Popconfirm, Divider, Alert } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { TUser } from "../../../../redux-modules/declarations/maps/auth";
import { selectorDepartmentList } from "../../../../redux-modules/selectors/selectorsDepartments";
import { selectorGroupsList } from "../../../../redux-modules/selectors/selectorsGroups";
import { UIDatePicker } from "../../../ui/DatePicker";
import UIModal from "../../../ui/Modal";
import { UISelect } from "../../../ui/Select";
import { UIText } from "../../../ui/Text";
import apiClient from "../../../../utils/apiClient";
import { showNotification } from "../../../../utils/showNotification";
import { API_ENDPOINTS } from "../../../../constants/api";
import { UIButton } from "../../../ui/Button";
import { actionShiftListRequest } from "../../../../redux-modules/actions/actionsShifts";
import '../../../../theme/css/custom.css';



const { Option } = UISelect;

interface Props {
  isModalVisible: boolean;
  closeModal: () => void;
  userList: TUser[];
  onOk: (
    users_id: string[],
    start_date_from: string,
    start_date_to: string,
    end_date_from: string,
    end_date_to: string,
    group_id?: string,
    department_id?: string,
  ) => void;
  currentDateSelected: moment.Moment;
}
export const RepeatShiftModal = ({
  isModalVisible,
  closeModal,
  userList,
  onOk,
  currentDateSelected,
}: Props): JSX.Element => {
  const dispatch = useDispatch();
  const groupList = useSelector(selectorGroupsList);
  const departmentList = useSelector(selectorDepartmentList);
  const [selectedGroup, setSelectedGroup] = useState<string>(
    groupList.data.length ? groupList.data[0].id : "",
  );
  const [selectedDepartment, setSelectedDepartment] = useState<string>();

  const [selectedSourceUser, setSelectedSourceUser] = useState<string>();
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const [selectedSourceDate, setSelectedSourceDate] = useState<moment.Moment>(
    moment().subtract(1, "week"),
  );
  
  const [selectedDestinationStart, setSelectedDestinationStart] = useState<moment.Moment>(
    moment().add(1, "week")
  );
  const [selectedDestinationEnd, setSelectedDestinationEnd] = useState<moment.Moment>(
    moment().add(1, "week")
  );

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [extraMessage, setExtraMessage] = useState<ReplyResponse | null>(null);
  interface ExtraMessage{
    id: string,
    message?: string,
    name: string,
    date?: string[]
  }

  interface ReplyResponse{
    message: string,
    extra?: ExtraMessage[]
  }

  enum ReplyOption{
    GRUPPO = "Gruppo",
    UTENTE = "Utente"
  }

  const [selectedReplyOption, setSelectedReplyOption] = useState<string>(ReplyOption.GRUPPO);

  const customFormat: DatePickerProps["format"] = value =>
    `${value.clone().startOf("week").format("DD/MM/YYYY")} - ${value
      .clone()
      .endOf("week")
      .format("DD/MM/YYYY")}`;

  const handleReplyOptionChange = (e: RadioChangeEvent) => {
    const value = e.target.value;
    setSelectedReplyOption(value);
  };

  useEffect(() => {
    if (!isModalVisible) {
      setSelectedGroup(groupList.data.length ? groupList.data[0].id : "");
      setSelectedDepartment(undefined);
      setSelectedUsers([]);
    }
  }, [isModalVisible]);

  useEffect(() => {
    setExtraMessage(null);
    setSelectedDepartment(undefined);
    setSelectedSourceUser(undefined);
    setSelectedUsers([]);

    switch(selectedReplyOption){
      case ReplyOption.GRUPPO:
        setSelectedGroup(groupList.data.length ? groupList.data[0].id : "");
        break;

      case ReplyOption.UTENTE:
        setSelectedGroup("");
        break;

      default:
        break;
    }
  }, [selectedReplyOption]);

  const handleOk = async () => {
    try{
      setExtraMessage(null);
      
      if(!selectedSourceDate){
        showNotification("error", "Oops..", "Selezionare la settimana di origine");
        return;
      }

      if(!selectedDestinationStart){
        showNotification("error", "Oops..", "Selezionare la settimana di destinazione iniziale");
        return;
      }

      if(!selectedDestinationEnd){
        showNotification("error", "Oops..", "Selezionare la settimana di destinazione finale");
        return;
      }

      const sourceDate = selectedSourceDate.clone().startOf("week").format("YYYY-MM-DD");
      const destinationDateStart = selectedDestinationStart.clone().startOf("week").format("YYYY-MM-DD");
      const destinationDateEnd = selectedDestinationEnd.clone().startOf("week").format("YYYY-MM-DD");

      let url = "";
      let body = {
        source_date: sourceDate,
        destination_date_start: destinationDateStart,
        destination_date_end: destinationDateEnd
      };

      if(selectedReplyOption === ReplyOption.GRUPPO){

        if(!selectedGroup){
          showNotification("error", "Oops..", "Selezionare il gruppo");
          return;
        }

        body = {...body, ...{group_id: selectedGroup}};

        if(selectedDepartment){
          body = {...body, ...{deparment_id: selectedDepartment}};
        }

        url = API_ENDPOINTS.REPLY_BY_GROUP;
      }else{

        if(!selectedSourceUser){
          showNotification("error", "Oops..", "Selezionare utente sorgente");
          return;
        }

        if(selectedUsers.length == 0){
          showNotification("error", "Oops..", "Seleziona almento un utente target");
          return;
        }

        
        body = {...body, ...{source_user_id: selectedSourceUser, targets_user_id: selectedUsers }};
        url = API_ENDPOINTS.REPLY;
      }

      console.log(body);

      setConfirmLoading(true);

      const response = await apiClient.post(url, body);

      if(response.status == 200 || response.status == 206){
        showNotification("success", "Replica Turni", response.data.message);

        if(response.status == 206){
          const extra : ReplyResponse = {message: response.data.message, extra: response.data.extra};
          setExtraMessage(extra);
        }


        const calendartSelectedStart = currentDateSelected.clone().startOf("week").format("YYYY-MM-DD");
        const calendartSelectedEnd = currentDateSelected.clone().startOf("week").add(6, "days").format("YYYY-MM-DD");

        dispatch(actionShiftListRequest({ date_from: calendartSelectedStart,  date_to: calendartSelectedEnd}));
      }
      
      setConfirmLoading(false);
    
    }catch(err){

      // Caso in cui err ha la response della chiamata perché l'api non ha restituito 200
      // @ts-ignore 
      if(err.response){
        // @ts-ignore
        const response: AxiosResponse = err.response;

        if(response.data){
          const info = response.data;
          showNotification("error", "Oops..", info.message);

          if(info.extra){
            const extra : ReplyResponse = {message: response.data.message, extra: response.data.extra};
            setExtraMessage(extra);
          }
        }

      }else{
        showNotification("error", "Oops..", "Si è verificato un imprevisto, riprovare.");
      }

      setConfirmLoading(false);
    }
    
    /*
    if (selectedGroup || selectedDepartment || selectedUsers.length > 0) {
      onOk(
        selectedUsers,
        selectedStartDate.clone().startOf("week").format("YYYY-MM-DD"),
        selectedStartDate.clone().endOf("week").format("YYYY-MM-DD"),
        selectedStartDate.clone().add(1, "week").startOf("week").format("YYYY-MM-DD"),
        selectedEndDate.clone().endOf("week").format("YYYY-MM-DD"),
        selectedGroup,
        selectedDepartment,
      );
    }
    closeModal();*/
  };

  function showExtraMessage(extraMessage: ReplyResponse){
    return <Row style={{ marginTop: "15px" }}>
            <Col span={24}>
              <UIText strong>{extraMessage.message}</UIText>
              <br />
              {extraMessage.extra?.map(extra => 
                <Alert
                  key={"extraMessage_" + extra.id}
                  message={extra.name}
                  style={{marginBottom: "2px"}}
                  description={
                    <Row>
                      {
                        extra.message ? 
                          <Col span={24}>
                            <UIText>{extra.message}</UIText>
                          </Col> 
                          : <></>
                      }

                      {
                        extra.date ? 
                          extra.date.map(
                            (date, index) => 
                            <Col key={"extraMessageDate_" + index} span={24}>
                              <UIText>{date}</UIText>
                            </Col>
                          ) 
                          : <></>
                      }
                    </Row>
                  }
                  type="warning"
                  showIcon={true}
                />
              )}
            </Col>
          </Row>
  }

  return (
    <UIModal
      width={600}
      title={"Replica Turni"}
      visible={isModalVisible}
      maskClosable={false}
      onCancel={closeModal}
      footer = {null}
    >
      {/* WARNING */}
      <Alert 
        message="Attenzione, durante la fase di replica, verranno sovrascritti tutti i turni di destinazione" 
        type="error"
        showIcon={false}
        style={{textAlign: "center"}}
      /> 
      
      <br />

      <Row style={{ marginBottom: "4px" }}>
        <Col span={12}>
          <UIText>Seleziona tipologia di replica:</UIText>
          <Radio.Group
          options={Object.values(ReplyOption)}
          defaultValue={ReplyOption.GRUPPO}
          optionType="button"
          buttonStyle="solid"
          onChange={handleReplyOptionChange}
          value={selectedReplyOption}/>
        </Col>
      </Row>

      <Row style={{ marginBottom: "14px" }}>
        <UIText style={{
            fontSize: "0.9em",
            fontStyle: "italic",
            lineHeight: "normal",
            marginTop: "5px",
            color: "#707070"
          }}>
            {selectedReplyOption === ReplyOption.GRUPPO ? 
            "Replica i turni settimanali di un gruppo o reparto specifico e li distribuisce nell'intervallo di tempo definito tra due settimane selezionate." 
            : "Replica i turni settimanali di un dipendente e li distribuisce nell'intervallo di tempo definito tra due settimane selezionate su altri dipendenti."}
        </UIText>
      </Row>

      {
        selectedReplyOption === ReplyOption.GRUPPO ? 

        // Replica per Gruppi
        <Row gutter={[8, 8]} style={{ marginBottom: "10px" }}>
          <Col span={8}>
            <Row>
              <Col>
                <UIText>Gruppo:</UIText>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <UISelect
                  showSearch
                  value={selectedGroup}
                  style={{ width: "100%" }} //@ts-ignore
                  onChange={value => setSelectedGroup(value)}
                  filterOption={(input, option) =>
                    ((option!.children as unknown) as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {groupList.data.map(e => (
                    <Option key={e.id} value={e.id}>
                      {e.name}
                    </Option>
                  ))}
                </UISelect>
              </Col>
            </Row>
          </Col>
          {selectedGroup && (
            <Col span={8}>
              <Row>
                <Col>
                  <UIText>Reparto:</UIText>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <UISelect
                    showSearch
                    value={selectedDepartment}
                    placeholder="Tutti"
                    style={{ width: "100%" }} //@ts-ignore
                    onChange={value => setSelectedDepartment(value)}
                    filterOption={(input, option) =>
                      ((option!.children as unknown) as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    <Option value={undefined}>Tutti</Option>
                    {departmentList.map(e => (
                      <Option key={e.id} value={e.id}>
                        {e.name}
                      </Option>
                    ))}
                  </UISelect>
                </Col>
              </Row>
            </Col>
          )}
        </Row> 

          : 

        // Replica per Utenti
        <Row gutter={[8, 8]} style={{ marginBottom: "10px" }}>
          <Col span={8}>
            <Row>
              <Col>
                <UIText>Utente di riferimento:</UIText>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <UISelect
                  showSearch
                  value={selectedSourceUser}
                  placeholder={"Seleziona utente"}
                  style={{ width: "100%" }}
                  //@ts-ignore
                  onChange={value => setSelectedSourceUser(value)}
                  filterOption={(input, option) =>
                    ((option!.children as unknown) as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {userList.map(e => (
                    <Option key={e.id} value={e.id}>
                      {e.surname + " " + e.name}
                    </Option>
                  ))}
                </UISelect>
              </Col>
            </Row>
          </Col>
          <Col span={16}>
            <Row>
              <Col>
                <UIText>Utenti di destinazione:</UIText>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <UISelect
                  mode="multiple"
                  showSearch
                  value={selectedUsers}
                  placeholder={"Tutti"}
                  style={{ width: "100%" }}
                  //@ts-ignore
                  onChange={value => setSelectedUsers(value)}
                  filterOption={(input, option) =>
                    ((option!.children as unknown) as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {userList.map(e => (
                    <Option key={e.id} value={e.id}>
                      {e.surname + " " + e.name}
                    </Option>
                  ))}
                </UISelect>
              </Col>
            </Row>
          </Col>
        </Row>  
      }

      <Row gutter={[14, 14]} style={{ marginBottom: "10px" }}>
        <Col span={12}>
          <UIText>Settimana di origine:</UIText>
          <CustomWeekPicker
            value={selectedSourceDate}
            //@ts-ignore
            onChange={(v: Moment | null) => setSelectedSourceDate(v)}
            picker="week"
            format={customFormat}
            disabledDate={(current) => {
              // Disabilita settimane future, ritorna TRUE quelle da disabilitare
              // disabledDate viene richiamata per ogni data visualizzata nel calendario
              const startOfWeek = current.clone().startOf("week");
              return startOfWeek.isSameOrAfter(moment().startOf("week"));
            }}
          />
        </Col>
      </Row>

      <Row gutter={[14, 14]}>
        <Col span={12}>
          <UIText>Settimana di destinazione iniziale:</UIText>
          <CustomWeekPicker
            value={selectedDestinationStart}
            //@ts-ignore
            onChange={(v: Moment | null) => setSelectedDestinationStart(v)}
            picker="week"
            format={customFormat}
            disabledDate={(current) => {
              // Disabilita settimane future, ritorna TRUE quelle da disabilitare
              // disabledDate viene richiamata per ogni data visualizzata nel calendario
              const startOfWeek = current.clone().startOf("week");
              return startOfWeek.isSameOrBefore(moment().startOf("week"));
            }}
          />
        </Col>
        <Col span={12}>
          <UIText>Settimana di destinazione finale:</UIText>
          <CustomWeekPicker
            value={selectedDestinationEnd}
            //@ts-ignore
            onChange={(v: Moment | null) => setSelectedDestinationEnd(v)}
            picker="week"
            format={customFormat}
            disabledDate={(current) => {
              // Disabilita settimane future, ritorna TRUE quelle da disabilitare
              // disabledDate viene richiamata per ogni data visualizzata nel calendario
              const startOfWeek = current.clone().startOf("week");
              return startOfWeek.isSameOrBefore(moment().startOf("week"));
            }}
          />
        </Col>
      </Row>
      
      {
        extraMessage != null ? showExtraMessage(extraMessage) : <></>
      }
      

      <Divider/>

      {/*FOOTER*/}
      <Row justify="end" style={{ marginTop: 16 }}>
        <Col>
          <UIButton 
          style={{ borderRadius: "7px", marginRight: 8 }} 
          onClick={closeModal}>
              Chiudi
          </UIButton>
        </Col>

        <Col>
          <Popconfirm
            title="Sei sicuro di voler replicare i turni?"
            onConfirm={handleOk}
            okText="Sì"
            cancelText="No">
            <UIButton 
              type="primary"
              loading={confirmLoading}
              style={{ borderRadius: "7px" }}>
                Replica
            </UIButton>
          </Popconfirm>
        </Col>
      </Row>
    </UIModal>
  );
};

const CustomWeekPicker = styled(UIDatePicker)`
  .ant-picker-cell-week {
    display: none !important;
  }

  [aria-label="empty cell"] {
    display: none;
  }
`;
